import { useRef, useState } from 'react';

import { SearchOutlined } from '@mui/icons-material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { Box, Button, IconButton, InputAdornment, SxProps } from '@mui/material';

import { MetaAutoComplete, StoreAutoComplete, TipoLogisticaLojaAutoComplete } from 'components/autocompletes';
import { CissTextField } from 'components/fields';
import { ConfirmModal } from 'components/modal';
import { useConfigPedidoListContext } from 'pages/compra/configuracao-pedido/contexts';

export function ConfigPedidoHeaderActions({ sx }: { sx?: SxProps }) {
    const {
        selectedRows,
        setValueFilter,
        onAdd,
        onRemove,
        showSearchField,
        searchPlaceholder,
        addDisabled,
        removeDisabled,
        showFilters,
        valueFilterLojas,
        setValueFilterLojas,
        valueFilterMetas,
        setValueFilterMetas,
        valueFilterLogisticaLoja,
        setValueFilterLogisticaLoja,
    } = useConfigPedidoListContext();
    const inputRef = useRef<HTMLInputElement>(null);

    const [openRemoveModal, setOpenRemoveModal] = useState<boolean>(false);
    const selectedRowsLength = selectedRows.ids.size;

    return (
        <>
            <ConfirmModal
                open={openRemoveModal}
                setOpen={setOpenRemoveModal}
                confirm={() => onRemove(selectedRows.ids)}
                text={`Tem certeza que deseja remover ${selectedRowsLength} registro(s) selecionado(s)?`}
            />

            <Box
                sx={{
                    gap: 2,
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: 'center',
                    justifyContent: showSearchField ? 'normal' : 'flex-end',
                    mb: 2,
                    ...sx,
                }}
            >
                {showFilters && (
                    <>
                        <StoreAutoComplete
                            size="small"
                            sx={{ width: { xs: '100%', md: 250 } }}
                            defaultStore={false}
                            multiple={true}
                            value={valueFilterLojas}
                            onChange={(_e, newLojas) => setValueFilterLojas(newLojas)}
                        />

                        <MetaAutoComplete
                            size="small"
                            sx={{ width: { xs: '100%', md: 200 } }}
                            value={valueFilterMetas}
                            onChange={(_e, newMeta) => setValueFilterMetas(newMeta)}
                        />

                        <TipoLogisticaLojaAutoComplete
                            size="small"
                            sx={{ width: { xs: '100%', md: 200 }, mr: { xs: 'none', md: 'auto' } }}
                            multiple={true}
                            value={valueFilterLogisticaLoja}
                            onChange={(_e, newLogisticaLoja) => setValueFilterLogisticaLoja(newLogisticaLoja)}
                        />
                    </>
                )}

                {showSearchField && (
                    <CissTextField
                        inputRef={inputRef}
                        placeholder={searchPlaceholder}
                        label="Pesquisar"
                        size="small"
                        sx={{ width: { xs: '100%', md: '50%' }, mr: { xs: 'none', md: 'auto' } }}
                        deboundTime={500}
                        onChange={(e) => setValueFilter(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();

                                if (inputRef.current) {
                                    setValueFilter(inputRef.current.value);
                                }
                            }
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            edge="end"
                                            onClick={() => {
                                                if (inputRef.current) {
                                                    setValueFilter(inputRef.current.value);
                                                }
                                            }}
                                        >
                                            <SearchOutlined />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                )}

                {Boolean(selectedRowsLength) && (
                    <Button
                        variant="outlined"
                        color="error"
                        disabled={removeDisabled}
                        onClick={() => setOpenRemoveModal(true)}
                        startIcon={<DeleteOutlineOutlinedIcon />}
                        sx={{ height: 33, width: { xs: '100%', md: 'auto' } }}
                    >
                        Remover
                    </Button>
                )}

                <Button variant="contained" disabled={addDisabled} onClick={onAdd} sx={{ height: 33, width: { xs: '100%', md: 'auto' } }}>
                    Incluir
                </Button>
            </Box>
        </>
    );
}
